
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[article]",
      function () {
        return require("private-next-pages/help/[article]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[article]"])
      });
    }
  